import Link from "next/link";
import { SyntheticEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { TPopup } from "@/pages/api/admin/popup";

const Wrap = styled.div`
  position: fixed;
  width: 500px;
  margin: 0 0 0 -250px;
  top: 50%;
  left: 50%;
  transition-duration: 250ms;
  z-index: 100000;
  @media (max-width: 600px) {
    left: 20px;
    width: calc(100% - 40px);
    margin: 0;
  }
`;

const PopupImageWrap = styled(Link)`
  background-color: #fff;
`;

const PopupImage = styled.img`
  width: 100%;
  vertical-align: top;
`;

const PopupFooter = styled.div`
  display: flex;
  justify-content: space-between;
  height: 42px;
  background: #000;
  padding: 9px 15px;
  color: #fff;

  & > p {
    margin: 3px 0 0 0;
    cursor: pointer;
  }
`;

export default function Popup() {
  const [popup, setPopup] = useState<TPopup | null>(null);
  const [imageSize, setImageSize] = useState<[number, number]>([0, 0]);
  const { t } = useTranslation();

  useEffect(() => {
    async function init() {
      const newPopup = await fetchPopup();

      const popupTodayCloseStr = localStorage.getItem(`POPUP_TODAY_CLOSE`);
      if (Boolean(popupTodayCloseStr)) {
        const popupTodayCloseJson: { id: number; timestamp: number } = JSON.parse(popupTodayCloseStr as string);
        if (Date.now() - popupTodayCloseJson.timestamp < 1000 * 60 * 60 * 12) return setPopup(null);

        localStorage.removeItem(`POPUP_TODAY_CLOSE`);
      }

      setPopup(newPopup);
    }
    init();
  }, []);

  function handleTodayClose() {
    localStorage.setItem(`POPUP_TODAY_CLOSE`, JSON.stringify({ id: popup?.id, timestamp: Date.now() }));
    setPopup(null);
  }

  function onLoadImage(e: SyntheticEvent<HTMLImageElement, Event>) {
    setImageSize([e.currentTarget.width, e.currentTarget.height]);
  }

  if (!popup) return;

  return (
    <Wrap style={{ transform: `translateY(-${imageSize[1] / 2}px)` }}>
      <PopupImageWrap href={popup.url} target="__blank">
        <PopupImage src={popup.image} onLoad={onLoadImage} />
      </PopupImageWrap>
      <PopupFooter>
        <p onClick={handleTodayClose}>{t("popup.dont-show-this-again-today")}</p>
        <p onClick={() => setPopup(null)}>{t("popup.close")}</p>
      </PopupFooter>
    </Wrap>
  );
}

async function fetchPopup(): Promise<TPopup | null> {
  const res = await fetch("/api/popup", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });

  const result = await res.json();
  return result.result;
}
